export default "__VITE_ASSET__CB02G_yv__"